export enum TestimonialType {
  Kampfkunst,
  Vektoren,
}

export type Testimonial = {
  name: string;
  text: string;
  types: TestimonialType[];
};
